import React, { useState } from 'react';
import { PanelRequestForm } from './PanelRequestForm';
import { Button } from '../common/Button';
import { Package } from 'lucide-react';

export const RequestPanelPage: React.FC = () => {
  const [showForm, setShowForm] = useState(false);

  if (showForm) {
    return (
      <PanelRequestForm
        onClose={() => setShowForm(false)}
        onSuccess={() => setShowForm(false)}
      />
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#63B56F] to-[#193B4E] flex items-center justify-center p-4">
      <div className="bg-white rounded-lg shadow-xl p-8 max-w-md w-full text-center">
        <Package className="w-16 h-16 text-[#63B56F] mx-auto mb-4" />
        <h1 className="text-2xl font-bold text-gray-900 mb-4">
          Request Solar Panel Addition
        </h1>
        <p className="text-gray-600 mb-6">
          Can't find the solar panel you're looking for? Submit a request and our team will review and add it to our database.
        </p>
        <Button onClick={() => setShowForm(true)} className="w-full">
          Start Panel Request
        </Button>
      </div>
    </div>
  );
};
